// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__AnR1j","section":"styles_section__i2cZd"};